import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
export const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${ColorSF2.white};
  overflow-y: auto;
`;

export const ReportTableWrapper = styled.div`
  margin: 16px;
  width: 830px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReportTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  & th {
    width: 120px;
    background-color: ${ColorSF2.lightGray};
    font-size: 12px;
    font-weight: 100;
  }
  & td {
    padding: 5px;
    font-size: 12px;
  }
  & tr {
    border: 1px solid ${ColorSF2.mediumGray};
  }
  & th,
  td {
    border: 1px solid ${ColorSF2.mediumGray};
  }
`;

export const FramesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
